module.exports = __webpack_public_path__ + "img/participe.60492bcf.svg";